const { errors } = require('@transfeeradev/api-enums');
const ClearMaskService = require('../services/ClearMaskService');
const moment = require('@transfeeradev/moment');
const error = require('./error');
const success = require('./success');

const BILLET_BASE_DATE = '1997-10-07';

class SimpleBarcode {
  constructor(billet) {
    this._billet = billet;

    this._billet.barcode = ClearMaskService.clear(this._billet.barcode);
  }

  validate() {
    let barra = this.getLine();
    if (!barra) {
      return error(errors.ptBr.bil.INVALID_BARCODE, 'barcode');
    }
    barra = barra.replace(/[^0-9]/g, '');
    // CÁLCULO DO DÍGITO DE AUTO CONFERÊNCIA (DAC) - 5ª POSIÇÃO
    if (this.mod11('34191000000000000001753980229122525005423000') != 1) {
      return error(errors.ptBr.bil.INVALID_BARCODE, 'barcode');
    }
    if (barra.length < 47) barra = barra + '00000000000'.substr(0, 47 - barra.length);
    if (barra.length !== 47) {
      return error(errors.ptBr.bil.INVALID_BARCODE, 'barcode');
    }

    barra =
      barra.substr(0, 4) + barra.substr(32, 15) + barra.substr(4, 5) + barra.substr(10, 10) + barra.substr(21, 10);

    if (this.mod11(barra.substr(0, 4) + barra.substr(5, 39)) != barra.substr(4, 1)) {
      return error(errors.ptBr.bil.INVALID_BARCODE, 'barcode');
    }

    return success;
  }

  getData() {
    const isValid = this.validate().isValid;

    if (isValid) {
      return {
        value: this.getValue(),
        dueDate: this.getDueDate(),
        bankCode: this.getBank()
      };
    }

    return {
      value: 0,
      dueDate: null,
      bankCode: null
    };
  }

  getValue() {
    const line = this.getLine();
    const value = line.substr(37, 47);

    return Number(value) / 100;
  }

  getDueDate() {
    const barCode = this.getBarcode();
    const days = barCode.substr(5, 4);

    if (+days === 0) {
      return 0;
    }

    return moment(BILLET_BASE_DATE).add(days, 'days').startOf('day').format();
  }

  getBank() {
    const line = this.getLine();
    const bank = line.substr(0, 3);

    return bank;
  }

  convertLineToBarcode() {
    let barcode = this._billet.barcode;
    if (barcode.length !== 47) {
      throw new Error('Linha digitável inválida');
    }
    barcode =
      barcode.substr(0, 4) +
      barcode.substr(32, 15) +
      barcode.substr(4, 5) +
      barcode.substr(10, 10) +
      barcode.substr(21, 10);
    return barcode;
  }

  convertBarcodeToLine() {
    let line = this._billet.barcode;
    if (line.length !== 44) {
      throw new Error('Código de barras inválido');
    }

    let field1 = line.substr(0, 4) + line.substr(19, 1) + line.substr(20, 4);
    let field2 = line.substr(24, 5) + line.substr(24 + 5, 5);
    let field3 = line.substr(34, 5) + line.substr(34 + 5, 5);
    let filed4 = line.substr(4, 1); // Digito verificador
    let field5 = line.substr(5, 14); // Vencimento + Valor
    if (field5 === '0') {
      field5 = '000';
    }

    line = field1 + this.mod10(field1) + field2 + this.mod10(field2) + field3 + this.mod10(field3) + filed4 + field5;
    return line;
  }

  getBarcode() {
    const code = this._billet.barcode;
    if (code.length === 44) {
      return code;
    } else if (code.length === 47) {
      return this.convertLineToBarcode();
    } else {
      return null;
    }
  }

  getLine() {
    const code = this._billet.barcode;
    if (code.length === 44) {
      return this.convertBarcodeToLine();
    } else if (code.length === 47) {
      return code;
    } else {
      return null;
    }
  }

  mod10(number) {
    const codigo = number.split('').reverse();
    const somatorio = codigo.reduce((acc, current, index) => {
      let soma = Number(current) * (((index + 1) % 2) + 1);
      soma = soma > 9 ? Math.trunc(soma / 10) + (soma % 10) : soma;
      return acc + soma;
    }, 0);
    return Math.ceil(somatorio / 10) * 10 - somatorio;
  }

  mod11(number) {
    const codigo = number.split('').reverse();
    let multiplicador = 2;
    const somatorio = codigo.reduce((acc, current) => {
      const soma = Number(current) * multiplicador;
      multiplicador = multiplicador === 9 ? 2 : multiplicador + 1;
      return acc + soma;
    }, 0);
    const restoDivisao = somatorio % 11;
    const DV = 11 - restoDivisao;
    if (DV === 0 || DV === 10 || DV === 11) return 1;
    return DV;
  }
}

module.exports = SimpleBarcode;
